import React from 'react'
import { useDropzone } from 'react-dropzone';
import { Link, useNavigate } from 'react-router-dom'

const Home = (props) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));
  return (
    <>
    <div className='row'>
    <div className='col-lg-4'></div>
    <div className='col-lg-4' style={{marginTop:'200px',boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;'}}>
     <section className="container">
      
      <div {...getRootProps({ className: 'dropzone' })} style={{border: '1px dotted #bfbfbf', padding:'55px'}}>
        <input {...getInputProps()} />
        <p>Drag 'n' drop some files here, or click to select files</p>
      </div>
      
      <aside style={{marginTop:'20px'}}>
        <h4>Files</h4>
        <ul>{files}</ul>
        <Link to="/gallery"> <button type="button" class="btn btn-primary btn-lg btn-block"  style={{backgroundColor:'#fffb00', border:'none', boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',fontSize: '17px',
    color: 'black'}}>Next</button></Link>
      </aside>
    </section>
    </div>
    </div>
    <div className='col-lg-4'></div>
      
    </>
  )
}

export default Home
